function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M262.245 236.268c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.671-3.826-5.966-3.826c-3.294 0-5.965 1.713-5.965 3.826",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M263.414 236.937c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.67-3.826-5.965-3.826c-3.296 0-5.965 1.713-5.965 3.826z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M263.414 236.937v3.538c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826v-3.538",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M272.773 282.335l-38.737-29.493 37.212-28.332 38.736 29.493z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M309.984 267.901l-37.211 28.332-38.737-29.493m.859-163.775v14.23m-.859 135.646v14.231m38.737 15.263v13.898"
}), React.createElement("path", {
  d: "M262.245 149.662c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.671-3.826-5.966-3.826c-3.294 0-5.965 1.713-5.965 3.826",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M263.414 150.33c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.67-3.826-5.965-3.826c-3.296 0-5.965 1.713-5.965 3.826z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M263.414 150.33v3.538c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826v-3.538",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M272.773 195.728l-38.737-29.493 37.212-28.332 38.736 29.493z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M309.984 181.628l-37.211 28.332-38.737-29.493m0-14.231v14.23m38.737 15.262v14.658"
}), React.createElement("path", {
  d: "M187.155 85.23c0 2.113 2.67 3.826 5.966 3.826 3.295 0 5.965-1.713 5.965-3.826s-2.67-3.826-5.965-3.826-5.966 1.713-5.966 3.826",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M188.325 85.898c0 2.113 2.67 3.826 5.966 3.826 3.294 0 5.965-1.713 5.965-3.826s-2.671-3.826-5.965-3.826c-3.295 0-5.966 1.713-5.966 3.826z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M188.325 85.898v3.538c0 2.113 2.67 3.826 5.966 3.826 3.294 0 5.965-1.713 5.965-3.826v-3.538",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M197.683 131.296l-38.736-29.493 37.211-28.332 38.737 29.493z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M234.895 117.196l-37.212 28.332-38.736-29.493M310 254v14.231M158.947 101.803v14.231m38.736 15.262v14.658"
}), React.createElement("path", {
  d: "M104.245 142.995c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.671-3.826-5.966-3.826c-3.294 0-5.965 1.713-5.965 3.826",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M105.415 143.663c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.671-3.826-5.966-3.826c-3.295 0-5.965 1.713-5.965 3.826z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M105.415 143.663v3.54c0 2.111 2.67 3.825 5.965 3.825s5.966-1.714 5.966-3.826v-3.539",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M114.773 189.062l-38.737-29.493 37.212-28.332 38.736 29.493z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M151.984 174.961l-37.211 28.332L76.036 173.8m75.948-13.07v14.23m-75.948-15.391v14.23m38.737 15.263v14.658"
}), React.createElement("path", {
  d: "M196.41 209.366c0 2.113 2.672 3.826 5.967 3.826 3.295 0 5.966-1.713 5.966-3.826s-2.671-3.826-5.966-3.826c-3.295 0-5.966 1.713-5.966 3.826",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M197.58 210.035c0 2.113 2.671 3.826 5.966 3.826 3.296 0 5.966-1.713 5.966-3.826s-2.67-3.826-5.965-3.826c-3.296 0-5.966 1.713-5.966 3.826z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M197.58 210.035v3.538c0 2.113 2.671 3.826 5.966 3.826 3.296 0 5.966-1.713 5.966-3.826v-3.538",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M179.66 194.616c0 2.113 2.672 3.826 5.967 3.826 3.295 0 5.966-1.713 5.966-3.826s-2.671-3.826-5.966-3.826c-3.295 0-5.966 1.713-5.966 3.826",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M180.83 195.285c0 2.113 2.671 3.826 5.966 3.826 3.295 0 5.966-1.713 5.966-3.826s-2.67-3.826-5.966-3.826c-3.295 0-5.966 1.713-5.966 3.826z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M180.83 195.285v3.538c0 2.113 2.671 3.826 5.966 3.826 3.295 0 5.966-1.713 5.966-3.826v-3.538",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M190.189 240.683l-38.736-29.493 37.212-28.332L227.4 212.35z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M227.4 226.582l-37.211 28.332-38.736-29.493M227.4 212.35v14.232m-75.947-15.392v14.23m38.736 15.263v14.658"
}), React.createElement("path", {
  d: "M72.791 240.425c0 2.113 2.671 3.826 5.966 3.826 3.294 0 5.965-1.713 5.965-3.826s-2.67-3.826-5.965-3.826-5.966 1.713-5.966 3.826",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M73.961 241.093c0 2.113 2.671 3.826 5.965 3.826 3.295 0 5.966-1.713 5.966-3.826s-2.67-3.826-5.966-3.826c-3.294 0-5.965 1.713-5.965 3.826z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M73.961 241.093v3.538c0 2.113 2.671 3.826 5.965 3.826 3.295 0 5.966-1.713 5.966-3.826v-3.538",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M98.356 271.668l-38.737-29.493 37.212-28.331 38.737 29.492zm37.212-28.332v14.231"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M59.605 242.175v14.23h.014L98.356 285.9l37.212-28.332m-37.212 14.1V285.9"
}), React.createElement("path", {
  d: "M98.373 247.338s-7.48 5.401-7.208 5.401l8.357 6.34-1.15-11.742z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M99.376 248.09s-7.479 5.402-7.208 5.402l8.357 6.34-1.149-11.742z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M100.526 259.832v3.555l-8.357-6.34v-3.554 2.53"
}), React.createElement("path", {
  d: "M115.873 235.838s-7.48 5.401-7.208 5.401l8.357 6.34-1.15-11.742z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M116.876 236.59s-7.479 5.402-7.208 5.402l8.357 6.34-1.149-11.742z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M118.026 248.332v3.555l-8.357-6.34v-3.554 2.53"
}), React.createElement("path", {
  d: "M99.207 222.171s-7.48 5.402-7.208 5.402l8.356 6.34-1.149-11.742z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M100.21 222.923s-7.48 5.403-7.208 5.403l8.356 6.34-1.149-11.743z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M101.359 234.665v3.555l-8.356-6.34v-3.555 2.531"
}), React.createElement("path", {
  d: "M130.373 151.004s-7.48 5.402-7.207 5.402l8.356 6.34-1.15-11.742z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M131.376 151.757s-7.479 5.402-7.208 5.402l8.357 6.34-1.149-11.742z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M132.526 163.499v3.555l-8.357-6.34v-3.555 2.53"
}), React.createElement("path", {
  d: "M173.373 202.004s-7.48 5.402-7.207 5.402l8.356 6.34-1.15-11.742z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M174.376 202.756s-7.479 5.403-7.208 5.403l8.357 6.34-1.149-11.743z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M175.526 214.499v3.555l-8.357-6.34v-3.555 2.53"
}), React.createElement("path", {
  d: "M180.207 93.338s-7.48 5.402-7.208 5.402l8.356 6.34-1.148-11.742z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M181.21 94.09s-7.48 5.402-7.208 5.402l8.356 6.34-1.149-11.742z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M182.359 105.832v3.555l-8.356-6.34v-3.554 2.53"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M87.776 155.324l6.169 4.781 7.374-5.397-6.16-4.834z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M88.966 155.324l6.17 4.781 7.373-5.397-6.159-4.834zm13.717-.571l.009 3.944c-.043.019-7.461 5.418-7.461 5.418"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M88.8 155.259v3.849l6.335 4.847v-3.881"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M181.442 221.324l6.169 4.781 7.374-5.397-6.158-4.834z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M182.632 221.324l6.17 4.781 7.374-5.397-6.159-4.834zm13.718-.571l.01 4.048-7.463 5.418"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M182.466 221.259v3.849l6.336 4.847v-3.881"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M246.442 251.99l6.169 4.782 7.374-5.397-6.158-4.833z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M247.632 251.99l6.17 4.782 7.374-5.397-6.159-4.833zm13.718-.57l.01 3.943c-.044.02-7.463 5.418-7.463 5.418"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M247.466 251.925v3.85l6.336 4.846v-3.88"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M248.109 165.324l6.169 4.781 7.374-5.397-6.16-4.834z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M249.3 165.324l6.168 4.781 7.374-5.397-6.159-4.834zm13.716-.571l.01 3.944c-.044.019-7.462 5.418-7.462 5.418"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M249.133 165.259v3.849l6.335 4.847v-3.881"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M280.859 164.574l6.169 4.781 7.374-5.397-6.16-4.834z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M282.05 164.574l6.168 4.781 7.374-5.397-6.159-4.834zm13.716-.571l.01 3.944c-.044.019-7.462 5.418-7.462 5.418"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M281.883 164.509v3.849l6.335 4.847v-3.881"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M207.609 101.49l6.169 4.782 7.374-5.397-6.16-4.833z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M208.8 101.49l6.168 4.782 7.374-5.397-6.159-4.833zm13.716-.57l.01 3.943c-.044.02-7.462 5.418-7.462 5.418"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M208.633 101.425v3.85l6.335 4.846v-3.88"
}), React.createElement("path", {
  fill: "#FFC5C5",
  d: "M266.154 178.87l-.632-4.6 5.23-2.705 6.763 1.804.54 4.237-4.778 3.532z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M267.206 179.11l-.27-4.6 4.869-2.705 6.762 1.804.54 4.238-4.778 3.72z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M279.109 177.786v3.487l-4.69 3.72-7.123-2.457-.09-3.427m7.123 2.457l.09 3.426M310 168v14.231"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 370 370",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide_3.svg